import { render, staticRenderFns } from "./TableEffect.vue?vue&type=template&id=1078892a&scoped=true"
import script from "./TableEffect.vue?vue&type=script&lang=js"
export * from "./TableEffect.vue?vue&type=script&lang=js"
import style0 from "./TableEffect.vue?vue&type=style&index=0&id=1078892a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078892a",
  null
  
)

export default component.exports